import { get, set } from '@/helper/localStorage'

export default {
  namespaced: true,

  state: () => ({
    rooms: get('roomChats', []),
    roomsMeta: null,
    messages: [],
    messagesMeta: null,
    isLoading: false,
    isLoadingRooms: false,
    isLoadingMessages: false,
    activeRoom: null,
  }),

  mutations: {
    SET_ROOMS(state, value) {
      set('roomChats', value)
      state.rooms = value
    },
    PUSH_ROOMS(state, value) {
      const data = state.rooms
      data.push(...value)

      state.rooms = data
      set('roomChats', data)
    },
    SET_ROOMS_META(state, value) {
      state.roomsMeta = value
    },
    SET_MESSAGES_META(state, value) {
      state.messagesMeta = value
    },
    SET_MESSAGES(state, value) {
      state.messages = value
    },
    PUSH_MESSAGES(state, value) {
      const data = state.messages
      data.push(...value)

      state.messages = data
    },
    SET_LOADING(state, value) {
      state.isLoading = value
    },
    SET_LOADING_MESSAGES(state, value) {
      state.isLoadingMessages = value
    },
    SET_LOADING_ROOMS(state, value) {
      state.isLoadingRooms = value
    },
    SET_ACTIVE_ROOM(state, value) {
      const chats = localStorage.getItem(`room-chat_chats_${value.id}`)

      // for instant load
      if (chats) {
        state.messages = JSON.parse(chats)
      } else {
        state.messages = []
        state.messagesMeta = null
      }

      state.activeRoom = value
    },
  },

  actions: {
    async getRooms({ commit }, page = 1) {
      try {
        commit('SET_LOADING_ROOMS', true)

        const url = '/v1/admin/room_chats'

        const response = await this._vm.$http.get(url, {
          params: {
            page,
            limit: 10,
          },
        })

        if (response.data.meta.current_page === 1) {
          commit('SET_ROOMS', response.data.data)
        } else {
          commit('PUSH_ROOMS', response.data.data)
        }

        commit('SET_ROOMS_META', response.data.meta)
        commit('SET_LOADING_ROOMS', false)

        return response.data.data
      } catch (error) {
        commit('SET_LOADING_ROOMS', false)
        return error
      }
    },
    async sendReply({ commit }, id) {
      commit('SET_LOADING', true)

      const url = `v1/adviser/reply/${id}/send`

      return this._vm.$http.post(url)
        .finally(() => {
          commit('SET_LOADING', false)
        })
    },
    async cancelReply({ commit }, id) {
      commit('SET_LOADING', true)

      const url = `v1/admin/room_chats/pending/${id}/cancel`

      return this._vm.$http.post(url)
        .finally(() => {
          commit('SET_LOADING', false)
        })
    },
    async getChat({ state, commit }, { roomId, page = 1 }) {
      try {
        commit('SET_LOADING_MESSAGES', true)

        const url = `/v1/admin/room_chats/${roomId}/chats`
        const response = await this._vm.$http.get(url, {
          params: {
            page,
            limit: 20,
          },
        })

        if (state.activeRoom.id === roomId) {
          if (response.data.meta.current_page === 1) {
            commit('SET_MESSAGES', response.data.data)
            // no need to save the old message into the local storage. The page 1 only.
            localStorage.setItem(`room-chat_chats_${roomId}`, JSON.stringify(response.data.data))
          } else {
            commit('PUSH_MESSAGES', response.data.data)
          }

          commit('SET_MESSAGES_META', response.data.meta)
        }

        commit('SET_LOADING_MESSAGES', false)

        return response.data.data
      } catch (error) {
        commit('SET_LOADING_MESSAGES', false)
        return error
      }
    },
    async sendMessage({ state, commit }, { message, uuid }) {
      commit('SET_LOADING', true)

      const url = `/v1/admin/room_chats/${state.activeRoom.id}/chats`

      return this._vm.$http.post(url, { message, uuid })
        .then(response => response.data)
        .finally(() => {
          commit('SET_LOADING', false)
        })
    },
  },
}
